import React from 'react';
import { faEye, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Collapse } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//STYLES
import { ContainerPontosAdicionados } from './styled';

//COMPONENTS
import ButtonCustom from '../../../../../../../../../../../../../../../../Components/ButtonCustom';

interface PropsAdicionados {
    pontos_selecionados_adicionados: any[]
    fake_loading: boolean
    deletarPontosSelecionados: Function
    /** Id da análise com os pontos destacados no mapa. */
    analise_destacada?: string | number | null
    /** Liga/desliga o destaque dos pontos daquela análise. */
    aoDestacarAnalise?: (item: any) => void
}

export const PontosAdicionados: React.FC<PropsAdicionados> = ({
    pontos_selecionados_adicionados,
    fake_loading,
    deletarPontosSelecionados,
    analise_destacada = null,
    aoDestacarAnalise,
}) => {

    const { Panel } = Collapse

    return (
        <ContainerPontosAdicionados>
            <Collapse accordion>
                {pontos_selecionados_adicionados.map((item, index) => (
                    <Panel
                        key={item?.id ?? index}
                        header={
                            <div className='adicionados__header'>
                                {/* Análise + profundidade, mesmo padrão do modal "Ver malha":
                                    só a profundidade repetia entre painéis (a mesma faixa
                                    pode ter várias análises), deixando itens idênticos. */}
                                <span className='adicionados__rotulo'>
                                    <div className='adicionados__rotulo__cor' style={{ background: item?.cor }} />
                                    <span className='adicionados__rotulo__analise'>{item?.analise_nome}</span>
                                    <span className='adicionados__rotulo__separador'>|</span>
                                    <span className='adicionados__rotulo__profundidade'>{item?.profundidade}</span>
                                </span>

                                {/* Destaca no mapa os pontos desta análise. `stopPropagation`
                                    impede que o clique também abra/feche o painel. */}
                                <div
                                    className='button__eye'
                                    style={{ '--cor-do-item': item?.cor } as React.CSSProperties}
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        aoDestacarAnalise?.(item)
                                    }}
                                    data-active={item?.id === analise_destacada}
                                    title='Visualizar pontos no mapa'
                                >
                                    <FontAwesomeIcon icon={faEye} fontSize={13} />
                                </div>
                            </div>
                        }
                    >
                        <div className='container__adicionados'>
                            <div className='header__adicionados'>
                                <h3 className='points-title'>Pontos ({item?.pontos_selecionados?.length ?? 0})</h3>

                                <ButtonCustom
                                    onClick={() => deletarPontosSelecionados(item?.id)}
                                    danger
                                    type='tertiary'
                                    loading={fake_loading}
                                    disabled={fake_loading}
                                    icon={<FontAwesomeIcon icon={faTrash} />}
                                >
                                    Remover
                                </ButtonCustom>
                            </div>

                            <div className='points-grid'>
                                {item?.pontos_selecionados?.map((point, index) => (
                                    <div
                                        key={index}
                                        className='point-card'
                                        style={
                                            {
                                                '--cor-do-item': point?.COR ?? item?.cor,
                                            } as React.CSSProperties
                                        }
                                    >
                                        {point?.NOME?.toString().padStart(2, '0')}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </Panel>
                ))}
            </Collapse>
        </ContainerPontosAdicionados>
    )
}
